/* src/app/components/payroll/timesheets/timesheet-payroll-processing/timesheet-payroll-run-errors/timesheet-payroll-run-errors.component.css */
.table-style {
  width: 100%;
}
.details-header {
  display: flex;
  align-items: center;
  gap: 16px;
}
/*# sourceMappingURL=timesheet-payroll-run-errors.component-7URC7BQU.css.map */
